import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Row, Col } from "react-bootstrap";
import { CurrencyField, FormInput } from "MODULES/shared/components/Forms";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { properCase } from "LIB/formatters/text";
import { QUANTITY } from "APP_ROOT/constants";
import {
  APPROVAL_STATUS,
  EXPECTED_COMPONENT,
  REMAINING_COST,
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_REJECTED,
  TRANSFER_COST
} from "../../../../constants";
import NoteTooltip from "../../../../../shared/components/NoteTooltip/NoteTooltip";

function ExpectedComponentSection({
  disabled,
  getInitialFieldValue,
  getFieldValue,
  setFieldValue,
  requestedAction
}) {
  if (requestedAction !== EXPECTED_COMPONENT) {
    return null;
  }

  const setRemainingCost = () => {
    const initialRemainingCost = getInitialFieldValue(REMAINING_COST);
    const initialTransferCost = getInitialFieldValue(TRANSFER_COST) || 0;
    const transferCost = getFieldValue(TRANSFER_COST) || 0;
    const initialQuantity = getInitialFieldValue(QUANTITY) || 0;
    const quantity = getFieldValue(QUANTITY) || 0;

    let newval =
      Number(initialRemainingCost) -
      Number(transferCost) * Number(quantity) -
      Number(initialTransferCost) * Number(initialQuantity);

    newval = newval < 0 ? 0 : newval;

    setFieldValue(REMAINING_COST)(newval);
  };

  return (
    <Row>
      <Col md={4}>
        <Field
          name={QUANTITY}
          component={FormInput}
          label="Qty"
          onBlur={setRemainingCost}
          disabled={Number(getInitialFieldValue(QUANTITY)) > 0}
          required
        />
      </Col>
      <Col md={4}>
        <CurrencyField
          name={TRANSFER_COST}
          label={[
            properCase(TRANSFER_COST),
            <NoteTooltip
              color="rgba(255, 255, 255, 0.25)"
              icon="fa-info-circle"
              note="Please indicate amount of remaining cost to transfer from the main component to this sub-component"
            />
          ]}
          onBlur={setRemainingCost}
          disabled={disabled}
          required={[
            REPAIR_EVALUATION_APPROVED,
            REPAIR_EVALUATION_REJECTED
          ].includes(getFieldValue(APPROVAL_STATUS))}
        />
      </Col>
      <Col md={4}>
        <Field
          name={REMAINING_COST}
          label={properCase(REMAINING_COST)}
          disabled
          component={CurrencyField}
        />
      </Col>
    </Row>
  );
}

export default withFieldAccessors(ExpectedComponentSection);

ExpectedComponentSection.propTypes = {
  disabled: PropTypes.bool,
  requestedAction: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/ExpectedComponentSection.jsx